export default __webpack_public_path__ + "static/media/35.8856eaea.png";